import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-invoice-methods',
  templateUrl: './invoice-methods.component.html',
  styleUrls: ['./invoice-methods.component.css']
})
export class InvoiceMethodsComponent implements OnInit {
    public itemsListInvoiceMethods: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadInvoiceMethods(): Promise<void> {
        this.itemsListInvoiceMethods = await this.datatask.Post(1762);
    }

    private async init() {
        this.loadInvoiceMethods();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('invoiceMethods', {
//        templateUrl: 'views/components/views/invoiceMethods/invoiceMethods.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['invoiceMethodsService', function (invoiceMethodsService) {
//            const vm = this;

//            vm.model = {
//                itemsListInvoiceMethods: []
//            };

//            async function loadInvoiceMethods() {
//                vm.model.itemsListInvoiceMethods = (await invoiceMethodsService.listInvoiceMethods());
//            }

//            vm.$onInit = function () {
//                loadInvoiceMethods();
//            };
//        }]
//    });
//})();
